import { List, ListItem, ListItemText, Divider,useTheme,Box } from '@mui/material';
import SkillDetails from './SkillDetails';
const SkillsView = ({data,selectedSkill,handleSkillClick}) => {
  const theme= useTheme();

  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ width: '30%' }}>
    <List sx={{  maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
      {Object.entries(data).map(item=> {
        const [skillId]= item
        return (
        <div key={skillId}>
          <ListItem
            button
            selected={selectedSkill === skillId}
            onClick={() => handleSkillClick(skillId)}
            sx={{
              '&.Mui-selected': {
                borderLeft: `4px solid ${theme.palette.primary.main}`,
              },
            }}
          >
            <ListItemText primary={skillId} />
          </ListItem>
          <Divider />
        </div>
      )})}
    </List>
    </Box>
      <Box sx={{ width: '70%' }}>
            <SkillDetails courses={data[selectedSkill]} skillId={selectedSkill}/>
      </Box>
      </Box>
  )
}

export default SkillsView
